import React from 'react';
import CircleButton from 'commons/src/components/buttons/CircleButton';
import MaterialIcon from 'commons/src/components/MaterialIcon';
import { DeviceWithKeyInfo } from 'commons/src/models/commonTypeScript';
import styles from './SelectedDeviceItem.module.scss';

export type Props = {
    device: DeviceWithKeyInfo;
    location: string;
    onRemove: (deviceSerialNumber: string) => void;
};

const SelectedDeviceItem = ({ device, location, onRemove }: Props): React.ReactElement => {
    const handleRemove = (): void => {
        onRemove(device.serialNumber);
    };

    return (
        <div className={styles.selectedDeviceItem}>
            <div className={styles.deviceInfo}>
                <div className={styles.deviceName}>{device.segmentName}</div>
                {location && <div className={styles.deviceLocation}>{location}</div>}
            </div>
            <div className={styles.removeButtonWrapper}>
                <CircleButton
                    onClick={handleRemove}
                    color="alert"
                    size="small"
                    iconName={<MaterialIcon name="remove" />}
                    testAttr={`remove-device-${device.serialNumber}`}
                />
            </div>
        </div>
    );
};

export default SelectedDeviceItem;
